<template>
    <div class="hris-page">
        <div class="hris-page-inner">
        <div class="hris-page-header">
            <div class="row items-center justify-between" style="gap: 12px;">
                <div>
                    <span class="hris-page-eyebrow">Training</span>
                    <h1 class="hris-page-title">E-Learning</h1>
                    <p class="hris-page-subtitle">Browse training videos and lessons.</p>
                </div>
                <q-btn-dropdown v-if="isAdmin" unelevated class="hris-q-primary" label="Add Video">
                    <q-list>
                        <q-item clickable v-close-popup @click="upload = true; videoType = 'local'">
                        <q-item-section>
                            <q-item-label>Upload Video</q-item-label>
                        </q-item-section>
                        </q-item>

                        <q-item clickable v-close-popup @click="prompt = true; videoType = 'yt'">
                        <q-item-section>
                            <q-item-label>Add Youtube Link</q-item-label>
                        </q-item-section>
                        </q-item>
                    </q-list>
                </q-btn-dropdown>
            </div>
        </div>

        <q-dialog v-model="upload">
            <div class="hris-modal">
                <div class="hris-modal-header">
                    <h2 class="hris-modal-title">Upload Video</h2>
                    <q-btn flat dense round v-close-popup aria-label="Close" @click="lessonName = ''; youtubeUrl = ''; details = ''; localUrl = '';">
                        <i class="fas fa-times"></i>
                    </q-btn>
                </div>
                <div class="hris-modal-body">
                    <div class="hris-form-row">
                        <div class="hris-form-field" style="flex-basis: 100%;">
                            <q-input dense outlined color="green" v-model="lessonName" autofocus @keyup.enter="upload = false" label="Title"></q-input>
                        </div>
                    </div>
                    <div class="hris-form-row">
                        <div class="hris-form-field" style="flex-basis: 100%;">
                            <q-input dense outlined color="green" v-model="details" autofocus @keyup.enter="upload = false" label="Video Details"></q-input>
                        </div>
                    </div>
                    <div class="lessons-upload-wrap">
                        <label class="custom-file-upload" for="file" @change="getVideo($event)">
                            <div class="text">
                                <span>{{ fileName === '' ? 'Click to upload video' : fileName}}</span>
                            </div>
                            <input type="file" id="file" accept="video/*" />
                        </label>
                    </div>
                </div>
                <div class="hris-modal-footer">
                    <q-btn unelevated class="hris-q-outline" label="Cancel" v-close-popup @click="lessonName = ''; youtubeUrl = ''; details = ''; localUrl = '';" ></q-btn>
                    <q-btn unelevated class="hris-q-primary" label="Add Video" v-close-popup @click="uploadToLocal()" ></q-btn>
                </div>
            </div>
        </q-dialog>

        <q-dialog v-model="prompt">
            <div class="hris-modal">
                <div class="hris-modal-header">
                    <h2 class="hris-modal-title">Enter Video Details</h2>
                    <q-btn flat dense round v-close-popup aria-label="Close" @click="lessonName = ''; youtubeUrl = ''; details = '';">
                        <i class="fas fa-times"></i>
                    </q-btn>
                </div>
                <div class="hris-modal-body">
                    <div class="hris-form-row">
                        <div class="hris-form-field" style="flex-basis: 100%;">
                            <q-input dense outlined color="green" v-model="lessonName" autofocus @keyup.enter="prompt = false" label="Title"></q-input>
                        </div>
                    </div>
                    <div class="hris-form-row">
                        <div class="hris-form-field" style="flex-basis: 100%;">
                            <q-input dense outlined color="green" v-model="youtubeUrl" autofocus @keyup.enter="prompt = false" label="Youtube Embed youtube"></q-input>
                        </div>
                    </div>
                    <div class="hris-form-row">
                        <div class="hris-form-field" style="flex-basis: 100%;">
                            <q-input dense outlined color="green" v-model="details" autofocus @keyup.enter="prompt = false" label="Video Details"></q-input>
                        </div>
                    </div>
                </div>
                <div class="hris-modal-footer">
                    <q-btn unelevated class="hris-q-outline" label="Cancel" v-close-popup @click="lessonName = ''; youtubeUrl = ''; details = '';" ></q-btn>
                    <q-btn unelevated class="hris-q-primary" label="Add Video" v-close-popup @click="createLesson()" ></q-btn>
                </div>
            </div>
        </q-dialog>

        <div v-if="lessons.length === 0" class="hris-panel">
            <div class="hris-empty">No lessons available yet.</div>
        </div>
        <div v-else class="hris-grid lessons-grid">
            <div v-for="lesson in lessons" :key="lesson.id" class="hris-content-card">
                <div class="lessons-media">
                    <div v-if="lesson.youtube_url">
                        <iframe class="video" frameBorder="0" allow="fullscreen;" :src="lesson.youtube_url"></iframe>
                    </div>
                    <div v-else>
                        <video :src="apiUrl + lesson.local_url" preload="none" loading="lazy" muted="false" loop="false" controls></video>
                    </div>
                </div>
                <div class="hris-content-card-body">
                    <h3 class="hris-content-card-title">{{ lesson.lesson_name }}</h3>
                    <p v-if="lesson.details" class="hris-content-card-text">{{ lesson.details }}</p>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import vueCookies from 'vue-cookies';

export default {
	data () {
		return {
           lessons: [],
           prompt: false,
           upload: false,
           lessonName: '',
           youtubeUrl: null,
           details: '',
           localUrl: null,
           isAdmin: false,
           fileName: '',
	    }
	},

	created(){
		this.getLessons()
        this.checkPermissions()
	},
    
	methods: {
        checkPermissions(){
            if(vueCookies.get('sgcchris').user.role_id === 1){
                this.isAdmin = true;
            }
        },

	    getLessons() {
	        axios.get(this.apiUrl + '/lessons', {
	            headers: { 'Authorization': `Bearer ${this.token}` },
	        }).then((response) => {
	            this.lessons = response.data.data
            	console.log('data:' + JSON.stringify(this.lessons))
				this.loading = false
	        }).catch((error) => {
	            console.log(error);
	        })
	   },

       getVideo(event){
            this.localUrl = event.target.files[0];
            this.fileName = event.target.files[0].name;
       },

       createLesson() {
            let formData = new FormData();
            formData.append("lessonName", this.lessonName);
            formData.append("youtubeUrl", this.youtubeUrl);
            formData.append("details", this.details);
            formData.append("video", this.localUrl);
            // formData.append("video_type", this.videoType);

            axios.create({
                baseURL: this.apiUrl,
                headers: { 'Authorization': `Bearer ${this.token}` }
            }).post('/create/yt/lesson', formData)
            .then((res) => {
                this.lessonName = ''
                this.youtubeUrl = null
                this.details = ''
                this.localUrl = null

                this.getLessons()

                this.$q.notify({
                    progress: true,
                    message: `Video Added Successfully.`,
                    color: 'green'
                }, 2000)

                // console.log(res.data.url)
            }).catch((error) => {
                this.lessonName = ''
                this.youtubeUrl = null
                this.details = ''
                this.localUrl = null

                this.$q.notify({
                    progress: true,
                    message: `Something went wrong.`,
                    color: 'red'
                }, 2000)
                console.log(error)
            });
       },

       uploadToLocal() {
        if(this.lessonName === '' || this.details === '' || this.localUrl === null){
            this.$q.notify({
                progress: true,
                message: `Please fill all the fields.`,
                color: 'red'
            }, 2000)
        }else{
            let formData = new FormData();
            formData.append("lessonName", this.lessonName);
            formData.append("youtubeUrl", null);
            formData.append("details", this.details);
            formData.append("video", this.localUrl);

            axios.create({
                baseURL: this.apiUrl,
                headers: { 'Authorization': `Bearer ${this.token}`, 'Content-Type': 'multipart/form-data' }
            }).post('/create/local/lesson', formData)
            .then((res) => {
                this.lessonName = ''
                this.youtubeUrl = null
                this.details = ''
                this.localUrl = null

                this.getLessons()

                this.$q.notify({
                    progress: true,
                    message: `Video Added Successfully.`,
                    color: 'green'
                }, 2000)

                // console.log(res.data.url)
            }).catch((error) => {
                this.lessonName = ''
                this.youtubeUrl = null
                this.details = ''
                this.localUrl = null

                this.$q.notify({
                    progress: true,
                    message: `Something went wrong.`,
                    color: 'red'
                }, 2000)
                console.log(error)
            });
        }
            
       },
	}
}
</script>

<style scoped>
.lessons-grid {
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
}

.lessons-media {
    background: #0f1218;
    aspect-ratio: 16 / 9;
    overflow: hidden;
}

.lessons-media iframe,
.lessons-media video {
    width: 100%;
    height: 100%;
    display: block;
    border: 0;
    object-fit: cover;
}

.lessons-upload-wrap {
    display: flex;
    justify-content: center;
    margin-top: 4px;
}

.custom-file-upload {
  min-height: 140px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border: 2px dashed var(--hris-border, #cacaca);
  background-color: var(--hris-surface-muted, #f1f3f5);
  padding: 1.5rem;
  border-radius: var(--hris-radius-sm, 8px);
}

.custom-file-upload .text {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.custom-file-upload .text span {
  font-weight: 500;
  color: var(--hris-text-secondary, #5c6370);
  font-size: 0.875rem;
}

.custom-file-upload input {
  display: none;
}
</style>
